export const PROCESS_API_URL =
  "https://manualaudiotranscript-zshmrdppoq-uc.a.run.app";
export const environment = {
  production: false,
  firebaseProjectId: "chartaisandboxenv",
  secureAudioStreamUrl: "https://secureaudiostream-zshmrdppoq-uc.a.run.app",
  manualJudgeUrl: "https://us-central1-chartaisandboxenv.cloudfunctions.net/runJudgeManually",
  correctionsBaseUrl: "https://us-central1-chartaisandboxenv.cloudfunctions.net/corrections",
  /** Judge Results API (BigQuery Cloud Function) */
  judgeResultsApiUrl: "https://us-central1-chartaisandboxenv.cloudfunctions.net/bigqueryReporting",
  /** ChartAI Agent Service (V3 pipeline) */
  agentServiceUrl: "https://chartai-agent-service-656238106124.us-central1.run.app",
};
